<template>
  <div id="direct-domain-update" v-if="detail.id !== ''" @click="cancelLookup()">
    <div class="expanded row">
      <div class="small-12 medium-5 columns">
        <div class="collapse row">
          <div class="column">
            <div class="row">
              <div class="column shrink">
                <label for="registrar" class="text-right middle">{{ 'Registrar'|t }} </label>
              </div>
              <div class="column">
                <input v-model="registrar" id="registrar" type="email" placeholder="foo@bar.com" class="text-center" />
              </div>
            </div>
          </div>
          <div class="column shrink">
            <button class="medium success button" @click="submitRegistrar">{{ 'Submit'|t }}</button>
          </div>
        </div>
      </div>
      <div class="small-12 medium-5 columns">
        <div class="collapse row">
          <div class="column">
            <div class="row">
              <div class="column shrink">
                <label for="contact" class="text-right middle">{{ 'Contact'|t }} </label>
              </div>
              <div class="column">
            <span :class="lookup.name === 'contact' && lookup.working ? 'autocomplete-wrapper working' : 'autocomplete-wrapper'">
              <input type="text" class="text-center" id="contact" v-model="contact" @keyup.stop="lookupContact('contact')" />
              <ul class="autocomplete-selection" v-if="lookupResults('contact').length > 0">
                <li class="autocomplete-item" v-for="res in lookupResults('contact')" :key="res.id" @click.stop="setContact(res.contactid, 'contact')">{{ contactLookupLabel(res)}}</li>
              </ul>
            </span>
              </div>
            </div>
          </div>
          <div class="column shrink">
            <button class="medium success button" @click="submitContact">{{ 'Submit'|t }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="expanded row align-left">
        <div class="small-12 medium-10 columns">
          <fieldset class="fieldset">
            <legend>{{ 'Domain statuses'|t }}</legend>
            <div class="expanded row small-up-1 medium-up-3">
              <div class="column" v-for="s in getStatusList()" :key="s">
                <label>
                  <input type="checkbox" v-model="statuses" :value="s" /> {{ s }}
                </label>
              </div>
            </div>
            <div class="columns text-center">
              <button class="medium success button" @click="submitStatuses">{{ 'Submit'|t }}</button>
            </div>
          </fieldset>
        </div>
    </div>
    <div class="expanded row align-left">
      <div class="small-12 medium-10 columns">
        <fieldset class="fieldset">
          <div class="columns text-center">
            <button class="medium warning button" @click="toggleSupSubmit">{{ 'Toggle %s status'|t('serverUpdateProhibited') }}</button>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api';

  export default {
    name: 'DirectDomainUpdateForm',
    props: {
      domain: {
        type: String,
        required: true,
      },
    },
    created() {
      let self = this;
      api.viewDomain(
        {name: self.domain},
        data => {
          self.detail = data;
          let statuses = this.getStatusList();
          for (let i in data.status) {
            if (statuses.indexOf(data.status[i]) > -1) {
              this.statuses.push(data.status[i])
            }
          }
        }
      );
    },
    data() {
      return {
        detail: {
          id: "",
          domain: this.domain,
          extensions: {},
        },
        registrar: "",
        contact: "",
        statuses: [],
        lookup: {
          delay: null,
          name: null,
          results: [],
          working: false
        }
      }
    },
    methods: {
      submitRegistrar() {
        let request = {
          domain: this.domain,
          registrar_email: this.registrar
        };

        api.changeDomainRegistrar(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Domain has been updated."
            }, {root: true});
          }
        );
      },
      submitContact() {
        let request = {
          domain: this.domain,
          contact_cid: this.contact
        };

        api.changeDomainContact(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Domain has been updated."
            }, {root: true});
          }
        );
      },
      submitStatuses() {
        let request = {
          domain: this.domain,
          statuses: this.statuses
        };

        api.changeDomainServerStatuses(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Domain has been updated."
            }, {root: true});
          }
        );
      },
      toggleSupSubmit() {
        api.toggleDomainSUPStatus(
          {domain: this.domain},
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Status serverUpdateProhibited has been toggled."
            }, {root: true});
          }
        )
      },
      lookupContact(name) {
        this.cancelLookup();

        if (this[name].length < 2) {
          return
        }

        this.lookup.name = name;
        this.lookup.working = true;

        this.lookup.delay = setTimeout(() => {
          let req = {
            contact: this[name]
          };
          api.lookupContact(
            req,
            data => {
              this.lookup.results = data.results;
              this.lookup.working = false;
              this.lookup.delay = null;
            },
            err => {
              this.lookup.results = [];
              this.lookup.name = null;
              this.lookup.working = false;
              this.lookup.delay = null;
            }
          )
        }, 500);

      },
      cancelLookup() {
        if (this.lookup.delay !== null) {
          clearTimeout(this.lookup.delay);
        }
        this.lookup.delay = null;
        this.lookup.results = [];
        this.lookup.name = null;
        this.lookup.working = false;
      },
      lookupResults(name) {
        return this.lookup.name === name ? this.lookup.results : [];
      },
      setContact(cid, name) {
        this[name] = cid;
        this.lookup.results = [];
        this.lookup.name = null;
      },
      contactLookupLabel(c) {
        let out = [c.contactid];

        if (c.name.length > 0) {
          out.push(c.name);
        }

        if (c.org.length > 0) {
          out.push(c.org);
        }

        return out.join(', ');
      },
      getStatusList() {
        return [
          "serverHold", "serverDeleteProhibited", "serverRenewProhibited",
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/domain/UpdateDirect.vue